// Utility per gestire teams e matches in localStorage

export function saveTeams(teams) {
  localStorage.setItem('teams', JSON.stringify(teams));
}

export function loadTeams() {
  try {
    return JSON.parse(localStorage.getItem('teams')) || [];
  } catch {
    return [];
  }
}

export function saveMatches(matches) {
  if (!Array.isArray(matches)) {
    console.error('[saveMatches] ERRORE: matches non è un array!', matches);
    return;
  }
  localStorage.setItem('matches', JSON.stringify(matches));
}

export function loadMatches() {
  try {
    return JSON.parse(localStorage.getItem('matches')) || [];
  } catch {
    return [];
  }
}

// --- Persistenza bracket eliminazione ---
export function saveBracket(bracket) {
  localStorage.setItem('bracket', JSON.stringify(bracket));
}

export function loadBracket() {
  try {
    return JSON.parse(localStorage.getItem('bracket')) || null;
  } catch {
    return null;
  }
}
